/* ============================================================
   PRODUCT TABS — behavior
   Save as assets/product-tabs.js
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function init(root) {
    var bar = root.querySelector('.product-tabs__bar');
    var indicator = root.querySelector('.product-tabs__indicator');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.product-tabs__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.product-tabs__panel'));
    var accordionToggles = Array.prototype.slice.call(root.querySelectorAll('.product-tabs__accordion-toggle'));

    if (!tabs.length || !panels.length) return;

    /* ---------- desktop: exclusive tabs ---------- */
    function activateTab(tab, opts) {
      opts = opts || {};
      tabs.forEach(function (t) {
        var isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.tabIndex = isActive ? 0 : -1;
      });
      panels.forEach(function (p) {
        var isActive = p.id === tab.getAttribute('data-target');
        p.classList.toggle('is-active', isActive);
        if (isActive) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
      moveIndicator(tab);
      if (opts.focus) tab.focus();
    }

    function moveIndicator(tab) {
      if (!indicator || !bar) return;
      var barRect = bar.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();
      indicator.style.width = tabRect.width + 'px';
      indicator.style.transform = 'translateX(' + (tabRect.left - barRect.left + bar.scrollLeft) + 'px)';
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          activateTab(next, { focus: true });
        }
      });
    });

    /* ---------- mobile: independent accordion ---------- */
    accordionToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var panel = toggle.closest('.product-tabs__panel');
        var body = panel.querySelector('.product-tabs__panel-body');
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        setBodyHeight(body, !expanded);
      });
    });

    function setBodyHeight(body, open) {
      if (!body) return;
      if (open) {
        body.style.maxHeight = body.scrollHeight + 'px';
      } else {
        body.style.maxHeight = '0px';
      }
    }

    function refreshOpenAccordionHeights() {
      accordionToggles.forEach(function (toggle) {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          var panel = toggle.closest('.product-tabs__panel');
          setBodyHeight(panel.querySelector('.product-tabs__panel-body'), true);
        }
      });
    }

    /* ---------- responsive setup ---------- */
    var mq = window.matchMedia(MOBILE_QUERY);

    function applyMode() {
      if (mq.matches) {
        // mobile: sync accordion open state to whichever tab is currently active
        accordionToggles.forEach(function (toggle) {
          var panel = toggle.closest('.product-tabs__panel');
          var isOpen = panel.classList.contains('is-active');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          setBodyHeight(panel.querySelector('.product-tabs__panel-body'), isOpen);
        });
      } else {
        var activeTab = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || tabs[0];
        moveIndicator(activeTab);
      }
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', applyMode);
    } else if (mq.addListener) {
      mq.addListener(applyMode);
    }

    window.addEventListener('resize', function () {
      refreshOpenAccordionHeights();
      var activeTab = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      if (activeTab && !mq.matches) moveIndicator(activeTab);
    });

    /* ---------- legacy hash deep-linking ----------
       Supports old-style anchors like #tab-description,
       #tab_enquiry, #additional-product-tab-1 by matching
       against each block's configured anchor_id. */
    function normalizeHash(hash) {
      return hash.replace(/^#/, '').toLowerCase().replace(/_/g, '-');
    }

    function matchTabFromHash() {
      var hash = window.location.hash;
      if (!hash) return null;
      var norm = normalizeHash(hash);
      var found = tabs.filter(function (t) {
        var anchor = (t.getAttribute('data-anchor') || '').toLowerCase();
        return anchor && (anchor === norm || norm.indexOf(anchor) !== -1 || anchor.indexOf(norm) !== -1);
      })[0];
      return found || null;
    }

    var hashTab = matchTabFromHash();
    if (hashTab) {
      activateTab(hashTab);
    }

    window.addEventListener('hashchange', function () {
      var t = matchTabFromHash();
      if (t) activateTab(t);
    });

    /* ---------- initial paint ---------- */
    // Wait a tick so layout/fonts settle before measuring for the indicator.
    window.requestAnimationFrame(function () {
      applyMode();
    });
  }

  function initAll() {
    document.querySelectorAll('.product-tabs').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is added/updated in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector ? e.target.querySelector('.product-tabs') : null;
    if (section) init(section);
  });
})();
